module.exports = __webpack_public_path__ + "static/media/re_bg3.8e56d638.png";